import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useAllInterests = () => {
  const { data: allInterests = [], isLoading, refetch } = useQuery({
    queryKey: ['allInterests'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('hobbies')
        .select('name')
        .order('name', { ascending: true });
      
      if (error) {
        console.error('Error fetching all interests:', error);
        throw error;
      }
      
      return data?.map((item: any) => item.name) || [];
    },
    staleTime: 60 * 60 * 1000, // 1 hora (dados raramente mudam)
    refetchOnWindowFocus: false,
  });

  return {
    allInterests,
    isLoading,
    refetch
  };
};


